import React from 'react';

import { SvgProps } from '../enums';

export const FlagOM: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55110"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55110)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#F50101"
      />
      <mask
        id="mask1_270_55110"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55110)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V4H16V0H0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8V12H16V8H0Z"
          fill="#5EAA22"
        />
        <rect width="6" height="12" fill="#F50101" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M5.38522 1.01642C5.38995 0.970809 5.33161 0.953261 5.30835 0.992777C5.12691 1.301 4.67212 2.03422 3.92349 2.99306V2.53422C3.85208 2.45661 3.62443 2.24782 3.62443 2.24782V1.78966L4.03627 1.41697L3.47064 0.999992L2.87446 1.41697L3.32509 1.78966V2.24782C3.32509 2.46752 3.05189 2.53422 3.05189 2.53422L3.00187 2.93837C2.3054 2.03397 1.87117 1.3288 1.68729 1.01362C1.66356 0.97294 1.60387 0.9921 1.61088 1.03867C1.66638 1.40725 1.83238 2.22505 2.29092 3.09822H2.16794V3.08196C2.16794 3.05794 2.14848 3.03848 2.12446 3.03848H1.07012C1.0461 3.03848 1.02664 3.05794 1.02664 3.08196V3.745C1.02664 3.76901 1.0461 3.78848 1.07012 3.78848H2.12446C2.14848 3.78848 2.16794 3.76901 2.16794 3.745V3.3969H2.30072C2.34576 3.50075 2.44919 3.57394 2.57014 3.57607C2.65464 3.70643 2.74627 3.83644 2.84564 3.96482C2.61706 3.94221 1.10638 3.8136 1.10638 4.36319C1.10638 4.69124 1.47382 4.86488 1.93464 4.95464C1.47065 5.37481 1.03269 5.77015 0.831185 5.95195C0.798491 5.98145 0.824048 6.03254 0.866789 6.02195C1.22663 5.93277 2.16986 5.65763 3.06777 5.04507L3.09574 5.04511C3.34862 5.04511 3.5245 4.93541 3.64675 4.78693C4.56001 5.53238 5.59321 5.87667 6.04171 6.00003C6.08824 6.01283 6.1134 5.9526 6.07375 5.92508C5.70947 5.67222 4.88802 5.06368 4.04808 4.17977L4.07012 4.15397C4.24148 3.95174 4.3908 3.74372 4.52091 3.53515C4.57535 3.50332 4.6187 3.45489 4.64385 3.3969H4.77664L4.77664 3.745C4.77664 3.76901 4.7961 3.78848 4.82012 3.78848H5.87446C5.89848 3.78848 5.91794 3.76901 5.91794 3.745V3.08196C5.91794 3.05794 5.89848 3.03848 5.87446 3.03848H4.82012C4.80898 3.03848 4.79883 3.04266 4.79113 3.04955C5.2223 2.1768 5.34888 1.36699 5.38522 1.01642ZM4.77664 3.09822L4.77664 3.08196L4.77678 3.0784L4.7668 3.09822H4.77664ZM2.82012 3.28041C2.82012 3.41403 2.71062 3.52235 2.57555 3.52235C2.44048 3.52235 2.33098 3.41403 2.33098 3.28041C2.33098 3.1468 2.44048 3.03848 2.57555 3.03848C2.71062 3.03848 2.82012 3.1468 2.82012 3.28041ZM4.12446 3.28041C4.12446 3.41403 4.23396 3.52235 4.36903 3.52235C4.5041 3.52235 4.61359 3.41403 4.61359 3.28041C4.61359 3.1468 4.5041 3.03848 4.36903 3.03848C4.23396 3.03848 4.12446 3.1468 4.12446 3.28041Z"
          fill="#F7FCFF"
        />
      </g>
    </g>
  </svg>
);
